import React from "react";
import {PHOTO, SCREEN, STEPS} from "../../data/siteData";
import {asset, GRAD, inkOn, stagger, TINT} from "../../utils";
import Icon from "../common/Icon";
import ImageSlot from "../common/ImageSlot";
import SectionIntro from "../common/SectionIntro";

// App screenshot cropped to the screen area, inside our own phone frame.
export const PhoneScreen = ({src, alt}) => (
    <img src={asset(src)} alt={alt} className="pb-screen-img"
         style={{width: SCREEN.width, left: SCREEN.left, top: SCREEN.top}}/>
);

const HowItWorks = () => (
    <>
        <SectionIntro
            id="how"
            pill={{icon: 'zap', text: 'Easy & convenient', bg: 'rgba(11,114,201,0.12)', color: '#0B72C9'}}
            title="The whole rental, done from your pocket"
            titleStyle={{maxWidth: '18ch', fontSize: 'clamp(32px,3.8vw,48px)'}}
            lead="No desk to find, no paperwork, no one to wait for. The box is the shop."
            leadMaxWidth="52ch"
            style={{paddingTop: 76}}
        />
        <section className="pb-container" style={{padding: '0 24px'}}>
            <div className="pb-steps">
                {STEPS.map((s, i) => (
                    <div key={s.num} className="pb-reveal pb-step hover-card-lift"
                         style={{borderTopColor: s.color, animationDelay: stagger(i)}}>
                        <div className="pb-step-media" style={{background: TINT[s.color]}}>
                            <span className="pb-step-num" style={{background: GRAD[s.color], color: inkOn(s.color)}}>
                                {s.num}
                            </span>
                            {s.photo ? (
                                <ImageSlot src={PHOTO.step} alt={s.shotAlt}/>
                            ) : (
                                <div className="pb-step-phone">
                                    <div className="pb-step-screen" style={{aspectRatio: SCREEN.ratio}}>
                                        <PhoneScreen src={s.shot} alt={s.shotAlt}/>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div style={{padding: 22}}>
                            <h3 className="pb-step-title">{s.title}</h3>
                            <p className="pb-step-body">{s.body}</p>
                        </div>
                        {i < STEPS.length - 1 && (
                            <span className="pb-step-arrow"><Icon name="arrow" size={17}/></span>
                        )}
                    </div>
                ))}
            </div>
        </section>
    </>
);

export default HowItWorks;
